import { render, staticRenderFns } from "./BackToHome.vue?vue&type=template&id=3b6787c8"
import script from "./BackToHome.vue?vue&type=script&lang=ts"
export * from "./BackToHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports